import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageTaxes() {
            return Auth.hasPermissionTo('franchise_manage_taxes');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tax-permission.js